@import "../../styles/mixins/form-search-bar";

.search-bar__form {
  @include from-search-bar;
  z-index: var(--z-index-form-search-bar, 1);
}
.search-bar__cancel {
  z-index: var(--z-index-form-search-bar, 1);
}

.guided__no-scroll {
  overflow: hidden;
}

.guided-host__input-active {
  @media (max-width: 720px) {
    position: unset;
    padding: 0;
    top: 0;
  }
}

uiaas-guided-search div.guided-pane {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  height: 90vh;
  max-height: 90vh;
  overflow: auto;
  z-index: var(--z-index-guided-pane, 25);
  padding-top: 16px;
  @media (min-width: 720px) {
    height: unset;
    top: calc(100% + 12px);
    padding-top: 0;
    border-radius: var(--qds-control-border-radius, 4px);
    box-shadow: 0 2px 5px rgb(98 100 105 / 50%);
  }

  &.guided-pane--hidden-no-data,
  &.guided-pane--hidden-no-focus {
    display: none;
  }

  ul {
    list-style-type: none;
    padding-inline-start: 0;
    margin-bottom: 0;
    margin-top: 0;
  }

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  .guided-keyboard-selected {
    background: #e6e6e6;
  }

  .guided-pane__suggestions-label,
  .guided-pane__search-history-section-label,
  .guided-pane__quick-links-toplabel {
    color: #626469;
    font-size: 16px;
    padding: 8px 12px;

    @media (max-width: 720px) {
      background-color: #f7f7f7;
      line-height: 25px;
      padding: 7px 16px;
      border-top: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
    }
  }

  .guided-pane__suggestions,
  .guided-pane__quick-links {
    a {
      text-decoration: none;
      border: 1px solid transparent;
    }

    span.highlight {
      font-weight: normal;
    }
  }

  .guided-pane__quick-links-list,
  .guided-pane__suggestions-list {
    padding-inline-start: 0;
  }

  .guided-pane__quick-links-image {
    float: left;
    width: 50px;
  }

  .guided-pane__quick-links-section-item {
    clear: both;
  }

  .guided-pane__suggestion-link,
  .guided-pane__quick-link {
    display: block;
    font-size: 18px;
    color: #333333;
    font-weight: 700;
    padding: 8px 12px;
    @media (min-width: 720px) {
      font-size: 16px;
    }
  }

  .guided-pane__search-history {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    text-align: left;
    display: block;
    padding: 8px 12px;
  }

  .guided-pane__suggestion-link:hover {
    @media (hover) {
      background: #e6e6e6;
    }
  }

  .guided-pane__quick-link:hover {
    @media (hover) {
      .guided-pane__quick-link-p {
        text-decoration: underline !important;
      }
    }
  }

  .guided-pane__suggestion-container,
  .guided-pane__quick-link-container {
    display: flex;
  }

  .guided-pane__suggestion-p,
  .guided-pane__quick-link-p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    line-height: 22px;
    font-weight: 700 !important;
    font-family: "ArialRoundedMTforSE_Latin", Arial, sans-serif;
  }

  .guided-pane__search-history-p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    line-height: 22px;
    margin-right: 20px;
  }

  .guided-pane__quartz-icon-wrapper {
    margin-right: 4px;
    padding-top: 1px;
    display: flex;
    align-items: center;
    svg {
      width: 20px;
      height: 20px;
    }
  }

  .guided-pane__quick-links-section-label {
    font-size: 14px;
    line-height: 20px;
    color: #626469;
    padding: 4px 12px;
    @media (max-width: 720px) {
      line-height: 25px;
      padding: 7px 16px;
    }
  }

  .guided-pane__quick-link-description {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #626469;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-top: 6px;
  }

  .guided-pane__quick-link-status {
    color: #626469;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-right: 0.5em;
  }

  /*
    autocorrection text should be:
        color: #9FA0A4;
        font-size: 14px !important;
        padding-bottom: 5px !important;
    */

  .guided-pane__suggestion-chips {
    //contains all chips for given slot (beforeTitle/afterTitle)
    display: inline-block;
  }

  .guided-pane__suggestion-chip {
    //a single chip
    display: inline-block;
    color: white;
    background-color: var(--qds-theme-signature-color-default, #008a16);
    padding: 0 4px;
    border-radius: 2px;
    margin: 1px 4px 1px 0;
    font-weight: 400;
  }

  //this is just a sample, class is taken from cssClass property of a chip
  .guided-chip-custom__secondary {
    //background-color: black;
    background-color: #9fa0a4;
    color: white;
  }

  .guided-chip-custom__premium {
    margin-right: 8px;
    color: #008a16;
    background-color: white;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
  }

  .guided-pane__chip-label {
    margin-right: 4px;
  }

  .guided-pane__suggestion-text,
  .guided-pane__quick-link-text {
    margin-right: 4px;
  }

  .guided-pane__see-all-results-item {
    height: 56px;
    border-top: 1px solid
      var(--srp-greyscale-super-light-gray-e-6-e-6-e-6, #e6e6e6);
    background: var(--srp-greyscale-100-background-fafafa, #fafafa);
    list-style-type: none;
  }

  .guided-pane__see-all-results-link {
    display: flex;
    float: right;
    height: 40px;
    padding: 8px 5px;
    margin-top: 8px;
    align-items: center;
    gap: 4px;
    cursor: pointer;
  }

  .guided-pane__see-all-results-link-text {
    color: var(--website-link-srp-specific-cta, #0a99ca);
    font-size: 16px;
    font-weight: 400;
  }

  .guided-pane__see-all-results-link-text:hover {
    color: var(--website-link-srp-specific-cta, #0a99ca);
    text-decoration: underline;
  }

  .guided-pane__see-all-results-link-icon {
    color: var(--website-link-srp-specific-cta, #0a99ca);
    cursor: pointer;
  }

  .guided-pane__no-results-item {
    border-top: 1px solid
      var(--srp-greyscale-super-light-gray-e-6-e-6-e-6, #e6e6e6);
    background: var(--qds-theme-control-background, #ffffff);
    list-style-type: none;
    padding: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .guided-pane__no-results-text {
    text-align: center;
    font-size: 14px;
    line-height: 22px;
  }

  .guided-pane__no-results-icon {
    margin-bottom: 8px;
  }

  .guided-pane__search-history-section-label {
    font-size: 14px;
    line-height: 20px;
    color: #626469;
    padding: 12px;
    margin-top: 8px;
    @media (max-width: 720px) {
      line-height: 25px;
      padding: 7px 16px;
    }
  }

  .guided-pane__search-history-section-item:hover {
    @media (hover) {
      background: #e6e6e6;
    }
  }

  .guided-pane__search-history-section-item {
    clear: both;
    display: flex;
    align-items: center;
  }

  .guided-pane__search-history-p {
    margin-right: 15px;
    display: -webkit-box;
    line-clamp: 2;
    line-height: 25px;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    display: -webkit-box;
  }
  qds-web-megamenu-content-banner {
    --qds-theme-signature-color-default: var(--qds-theme-text-subdued, #626469);
    --qds-theme-signature-color-hover: var(
      --qds-theme-signature-app-name-subdued,
      #677a7e
    );
  }

  &__footer {
    padding: 8px 16px 16px;
  }
}

.guided__backdrop {
  visibility: hidden;
  position: fixed;
  top: -100px;
  left: 0;
  width: 120vw;
  height: calc(100vh + 100px);
  background: white;
  z-index: var(--z-index-backdrop, 1);

  @media (min-width: 720px) {
    background: #333333;
    opacity: 0.7;
  }
}

.guided__backdrop--visible {
  visibility: visible;
}

uiaas-guided-search.guided-sdl-v1.mm-is-open {
  .guided__backdrop {
    background: white;
    opacity: 1;
    @media (min-width: 1200px) {
      background: #333333;
      opacity: 0.7;
    }
  }

  @media (max-width: 1200px) {
    div.guided-pane {
      right: -10px;
      left: -10px;
      top: 53px;
      padding-top: 10px;
      box-shadow: none;
    }
    .guided__backdrop {
      //position: absolute;
      top: 50px;
      left: -20px;
    }
    .guided-pane__suggestions-label,
    .guided-pane__quick-links-toplabel {
      background-color: #f7f7f7;
      line-height: 25px;
      padding: 7px 16px;
      border-top: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
    }
  }
}

.backdrop-fix {
  position: relative;
  z-index: 1;
}

uiaas-guided-search div.guided-pane[dir="rtl"] {
  .guided-pane__quartz-icon-wrapper {
    margin-right: 0px;
    margin-left: 4px;
  }
}

/*Different theming options for link highlighting, applied as a class to <uiaas-guided-search>*/
uiaas-guided-search {
  position: relative;
  // regarding different highlighting options, check:
  // https://stackoverflow.com/questions/5687035/css-bolding-some-text-without-changing-its-containers-size
  &.no-highlighting {
    div.guided-pane .guided-pane__suggestion-link,
    div.guided-pane .guided-pane__quick-link {
      font-weight: normal;
      color: black;
    }
  }

  &.quick-link-p {
    font-weight: 700 !important;
    font-family: "ArialRoundedMTforSE_Latin", Arial, sans-serif;
  }

  &.highlighting2 {
    div.guided-pane .guided-pane__suggestion-link,
    div.guided-pane .guided-pane__quick-link {
      text-shadow: 0 0 0 currentColor;
      font-weight: normal;

      span.highlight {
        text-shadow: none;
      }
    }
  }

  &.inverted-highlighting {
    div.guided-pane .guided-pane__suggestion-link,
    div.guided-pane .guided-pane__quick-link {
      text-shadow: none;
      font-weight: normal;

      span.highlight {
        text-shadow: 0 0 0 currentColor;
      }
    }
  }

  &.inverted-highlighting2 {
    div.guided-pane .guided-pane__suggestion-link,
    div.guided-pane .guided-pane__quick-link {
      text-shadow: none;
      font-weight: normal;

      span.highlight {
        text-shadow: 1px 0 1px currentColor;
      }
    }
  }

  &.single-line-clamp {
    .guided-pane__suggestion-p,
    .guided-pane__quick-link-p {
      -webkit-line-clamp: 2;
      line-clamp: 2;
      line-clamp: 2;
    }
  }
}

uiaas-guided-search {
  display: block;
  width: auto; // Required to set proper width for guided-pane for mozilla

  div.guided-pane {
    @media (max-width: 720px) {
      right: -10px;
      left: -10px;
      top: 110px;
      padding-top: 10px;
    }
  }
  @media (max-width: 720px) {
    .guided__backdrop {
      //position: absolute;
      top: 120px;
      left: -20px;
    }
  }
}

uiaas-guided-search.guided-sdl-v1 {
  div.guided-pane {
    @media (max-width: 720px) {
      top: 53px;
    }
  }
}

.guided-pane {
  .voice-search__top-message-title {
    margin: 16px 0;
  }

  .voice-search__top-message-subtitle {
    margin: 16px 0;
  }

  .voice-search__bottom-message {
    color: rgba(51, 51, 51, 1);
    font-size: 22px;
    margin: 16px 0;
  }

  .voice-search__container {
    position: relative;
    overflow: hidden;
    height: 90%;
    padding: 32px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mic-container {
    display: flex;
    align-items: center;
    justify-content: center;

    .circle {
      width: 110px;
      height: 110px;
      border-style: none;
      appearance: none;
      border-radius: 50%;
      background: #ffffff;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      transition: 0.5s;
      box-shadow:
        0 6px 10px 0 rgba(0, 0, 0, 0.14),
        0 1px 18px 0 rgba(0, 0, 0, 0.12),
        0 3px 5px -1px rgba(0, 0, 0, 0.2);

      i {
        color: #b2b1b1;
        font-size: 23px;
        transition: 0.9s;
      }
    }

    .circle.active {
      background: rgba(237, 237, 237, 1);

      i {
        color: #ffffff;
      }
    }
  }

  .ellipse-1 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 132px;
    height: 132px;
    border-radius: 50%;
    background: rgba(202, 224, 210, 0.3);
    animation: none;
  }

  .ellipse-2 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background: transparent;
    animation: none;
  }

  .active {
    .ellipse-1 {
      background: rgba(202, 224, 210, 0.3);
      animation: bounce 0.8s ease-in-out infinite 0.5s;
    }

    .ellipse-2 {
      background: rgba(0, 122, 39, 0);
      animation: bounce-2 0.8s ease-in-out infinite 0.5s;
    }
  }

  @keyframes bounce {
    0% {
      background-color: rgba(202, 224, 210, 0.1);
    }
    25% {
      background-color: rgba(202, 224, 210, 0.2);
    }
    75% {
      background-color: rgba(202, 224, 210, 0.35);
    }
    100% {
      background-color: rgba(202, 224, 210, 0.2);
    }
  }

  @keyframes bounce-2 {
    0% {
      background-color: rgba(0, 122, 39, 0.3);
    }
    25% {
      background-color: rgba(0, 122, 39, 0.25);
    }
    75% {
      background-color: rgba(0, 122, 39, 0.1);
    }
    100% {
      background-color: rgba(0, 122, 39, 0.25);
    }
  }
}

.mobile-voice-background {
  position: absolute;
  bottom: 0;
  @media (min-width: 400px) {
    transform: scale(1.2);
  }
  @media (min-width: 460px) {
    transform: scale(1.4);
  }
  @media (min-width: 530px) {
    transform: scale(1.6);
  }
  @media (min-width: 720px) {
    display: none;
  }
}

.guided-pane {
  .guided-pane__footer-voice-promo {
    padding: 16px;

    .voice-promo-banner__container {
      padding: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 24px;
      color: var(--qds-theme-signature-color-contrast);
      background-color: var(--qds-theme-text-subdued, #626469);
      border-radius: var(--qds-control-border-radius);
      flex-wrap: wrap;
    }

    @media (min-width: 720px) {
      .voice-promo-banner__container {
        flex-wrap: nowrap;
      }
    }

    .voice-promo-banner__title {
      font-family: var(--qds-font-family-brand);
      font-size: 18px;
      font-style: normal;
      font-weight: bold;
      margin: 0 0 8px;
      color: var(--qds-theme-signature-color-contrast);
      line-height: 24px;
    }

    .voice-promo-banner__subtitle {
      font: var(--qds-text-subdued);
      color: var(--qds-theme-signature-color-contrast);
      margin: 0;
      padding: 0;
      text-align: start;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
    }

    .voice-promo-banner__button {
      --qds-theme-control-border: var(--qds-theme-popup-background);
      --qds-theme-control-text-standard: var(--qds-theme-popup-background);
      --qds-theme-interactive-background-pressed: none;
      --qds-theme-interactive-background-hover: rgb(255 255 255 / 22%);
    }
  }
}

.uiaas-guided-read-only-input {
  pointer-events: none;
  caret-color: transparent;
}

.uiaas-guided-read-only-input:focus {
  outline: none;
}
